module.exports = __webpack_public_path__ + "static/apple_store_badge-e9cb9015bbf5bf6bb9216fd54c87d40a.svg";